import React from 'react';
import { useIntl } from 'react-intl';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../../common/views/SMLButton/SMLButton';
import { reelReviewMessages } from './reelReviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelReadyActionsProps {
  onApprove: () => void;
  onReject: () => void;
}

/** Approve and Reject of a ready reel (design c1). */
const ReelReadyActionsComponent: React.FC<ReelReadyActionsProps> = ({ onApprove, onReject }) => {
  const intl = useIntl();

  return (
    <div className={styles.actions}>
      <SMLButton color="primary" size="lg" omitCap leftIcon={faCheck} onClick={onApprove}>
        {intl.formatMessage(reelReviewMessages.approve)}
      </SMLButton>
      <SMLButton outline size="lg" omitCap onClick={onReject}>
        {intl.formatMessage(reelReviewMessages.reject)}
      </SMLButton>
      <p className={styles.tiny}>{intl.formatMessage(reelReviewMessages.approveNote)}</p>
    </div>
  );
};

export const ReelReadyActions = TypedMemo(ReelReadyActionsComponent);
